var _excluded = ["onScroll"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { ListView as SpectrumListView } from '@adobe/react-spectrum';
import { extractSpectrumHTMLElement, useContentRect, useOnScrollRef } from '@deephaven/react-hooks';
import { EMPTY_FUNCTION } from '@deephaven/utils';
import cl from 'classnames';
import { useSpectrumThemeProvider } from "../../theme/index.js";
import { Flex } from "../layout.js";
import { separateSpectrumProps } from "../utils/index.js";
import "./ListViewWrapper.css";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Helper component to wrap a ListView with the appropriate styling + scroll
 * handling. This is used by both the `@deephaven/components` `ListView` and
 * the `@deephaven/jsapi-components` `ListView` (via `ListViewNormalized`) to
 * ensure consistency.
 *
 * Note that This component will usually not be used directly. Instead, it is
 * recommended to use
 * - `@deephaven/components`'s `ListView` for non-table data sources
 * - `@deephaven/jsapi-components`'s `ListView` for table data sources
 */
export function ListViewWrapper(props) {
  var _styleProps$minHeight, _listViewProps$densit;
  var _separateSpectrumProp = separateSpectrumProps(props),
    ariaLabelProps = _separateSpectrumProp.ariaLabelProps,
    componentProps = _separateSpectrumProp.componentProps,
    styleProps = _separateSpectrumProp.styleProps;
  var _componentProps$onScr = componentProps.onScroll,
    onScroll = _componentProps$onScr === void 0 ? EMPTY_FUNCTION : _componentProps$onScr,
    listViewProps = _objectWithoutProperties(componentProps, _excluded);
  var _useSpectrumThemeProv = useSpectrumThemeProvider(),
    scale = _useSpectrumThemeProv.scale;
  var scrollRef = useOnScrollRef(onScroll, extractSpectrumHTMLElement);

  // Spectrum ListView crashes when it has zero height. Track the contentRect
  // of the parent container and only render the ListView when it has a non-zero
  // height. See https://github.com/adobe/react-spectrum/issues/6213
  var _useContentRect = useContentRect(extractSpectrumHTMLElement),
    contentRectRef = _useContentRect.ref,
    contentRect = _useContentRect.contentRect;
  return /*#__PURE__*/_jsx(Flex, _objectSpread(_objectSpread({
    direction: "column",
    ref: contentRectRef
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, styleProps), {}, {
    // Set min-height to 1px so that `ListView` is rendered whenever container
    // is visible. This prevents the height from shrinking to zero as a result
    // of a parent grid or flex container calculating content sizes. The
    // container height can still be zero when it is not being displayed such
    // as when one of its parents have `display: none`.
    minHeight: (_styleProps$minHeight = styleProps.minHeight) !== null && _styleProps$minHeight !== void 0 ? _styleProps$minHeight : 1,
    UNSAFE_className: cl('dh-list-view-wrapper', "dh-list-view-wrapper-density-".concat((_listViewProps$densit = listViewProps.density) !== null && _listViewProps$densit !== void 0 ? _listViewProps$densit : 'regular'), "dh-list-view-wrapper-scale-".concat(scale), styleProps.UNSAFE_className),
    children: contentRect.height === 0 ? null : /*#__PURE__*/_jsx(SpectrumListView, _objectSpread(_objectSpread({
      ref: scrollRef
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, ariaLabelProps), listViewProps))
  }));
}
export default ListViewWrapper;
//# sourceMappingURL=ListViewWrapper.js.map